// Pricing rules for DISPLAY in the browser. The server
// (backend/utils/calcPrices.js) recomputes every order total with the same
// rules, so keep these two files in sync — the server always wins.
export const SHIPPING_RATES = {
  post: 150, // 中華郵政
  tcat: 250, // 黑貓宅配
};
export const FREE_SHIPPING_THRESHOLD = 1000; // items subtotal >= NT$1,000 ships free
export const TAX_RATE = 0.05; // 5% of the items subtotal (shipping excluded)

// Items subtotal in whole NTD.
export const calcItemsPrice = (cartItems = []) =>
  Math.round(
    cartItems.reduce((acc, item) => acc + Number(item.price) * Number(item.qty), 0)
  );

// Shipping for a carrier id. Returns null when no carrier is chosen yet, so the
// UI can show "請選擇配送方式" instead of a misleading number.
export const calcShippingPrice = (itemsPrice, shippingMethodId) => {
  if (!Object.prototype.hasOwnProperty.call(SHIPPING_RATES, shippingMethodId)) {
    return null;
  }
  return itemsPrice >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_RATES[shippingMethodId];
};

export const calcTaxPrice = (itemsPrice) => Math.round(itemsPrice * TAX_RATE);

// "NT$1,234" — whole dollars with thousands separators.
export const formatNTD = (value) => {
  const n = Math.round(Number(value) || 0);
  return `NT$${n.toLocaleString('en-US')}`;
};
